import { Product } from './commonInterfaces'

export const getOrderProductsServiceType = (orderProducts: Product[]) => {
  return orderProducts.map((product: Product) => {
    return product.serviceType
  })
}
